import * as React from "react";
const SvgFiRrChocolate = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-chocolate_svg__a)">
      <path
        fill="#062147"
        d="m22.547 5.666-4.192-4.192a4.995 4.995 0 0 0-7.065 0L1.473 11.29a5.02 5.02 0 0 0 0 7.064l4.192 4.192a5.02 5.02 0 0 0 7.065 0l9.817-9.817a5.02 5.02 0 0 0 0-7.064m-7.724-3.657c1.433-.115 2.557 1.33 3.467 2.225l-2.543 2.542-3.467-3.467a3.33 3.33 0 0 1 2.543-1.3m2.109 13.51-3.551-3.551L15.747 9.6l3.553 3.553zm-3.753 3.753L9.628 15.72l2.34-2.34 3.55 3.55zM7.088 8.5l3.467 3.467-2.34 2.34-3.467-3.465zm4.88 2.054L8.5 7.088l2.366-2.366 3.467 3.467zm-9.96 4.269a3.37 3.37 0 0 1 1.327-2.568L6.8 15.72l-2.567 2.568c-.898-.913-2.333-2.03-2.224-3.466m5.07 6.31L5.646 19.7l2.569-2.568 3.55 3.55a3.164 3.164 0 0 1-4.687.452m14.056-9.816-.423.423-3.551-3.551 2.54-2.542 1.432 1.43a3.01 3.01 0 0 1 .002 4.24"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-chocolate_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrChocolate;
